angular.module('leanlaw').factory('processService', ['$q', 'leanLawApi', 'leanLawAuth', 'alerts', 'download', '$http', function ($q, leanLawApi, leanLawAuth, alerts, download, $http) {
  function processApi(invoices, option) {
    let process = $q.resolve();
    invoices.forEach(invoice => {
      invoice.process = {
        processing: true
      };
      if (option?.id === 'email') {
        invoice.deliveryState = 5;
        invoice.deliveryStatus = 5;
        invoice.deliveryFailureMessage = '';
      }
      process = process.then(() => {
        if (option.actions.statement) {
          return leanLawApi.addInvoiceTrustStatement({
            id: invoice.id
          }).then(processed => {
            invoice.process = {
              done: true
            };
            invoice.selected = false;
            return processed;
          }).catch(err => {
            invoice.process = {
              error: err.body.message
            };
          });
        }
        if (option.actions.adjustment) {
          if (!invoice.replenish) return $q.resolve();
          return leanLawApi.createInvoiceEvergreenAdjustment({
            id: invoice.id,
            clear: !!option.actions.clear
          }).then(processed => {
            invoice.process = {
              done: true
            };
            invoice.selected = false;
            return processed;
          }).catch(err => {
            invoice.process = {
              error: err.body.message
            };
          });
        }
        if (option.actions.undo || option.actions.recall) {
          const query = {
            id: invoice.id
          };
          const api = option.actions.undo ? leanLawApi.deleteInvoice(query) : leanLawApi.recallInvoice(query);
          return api.then(() => {
            invoice.process = {
              done: true,
              hide: true
            };
            invoice.totals = {
              amount: 0
            };
            invoice.selected = false;
          }).catch(err => {
            invoice.process = {
              error: err.body.message
            };
          });
        }
        if (option.actions.submit || option.actions.send) {
          return leanLawApi.processInvoice({
            id: invoice.id,
            body: option.actions,
            bulk: option.bulk
          }).then(processed => {
            invoice.process = {
              done: true
            };
            invoice.selected = false;
            return processed;
          }).catch(err => {
            invoice.process = {
              error: err.body.message
            };
          });
        }
        if (option.actions.emailCustomization) {
          if (!option.emailBody && invoice.id) return;
          option.emailBody.timeSheetId = invoice.id;
          option.emailBody.qbInvoiceId = invoice.accounting.id;
          let path = `${leanLawAuth.domain}/v1/customemail?modified=true`;
          if (option.emailBody.bulk) {
            path = `${leanLawAuth.domain}/v1/customemail?modified=true&bulk=true`;
          }
          return $http.post(path, {
            ...option.emailBody
          }, {
            headers: {
              'x-leanlaw-version': 'v1'
            }
          }).then(response => {
            // The interceptor resolves error responses, so check status
            if (response.status < 200 || response.status >= 300) {
              invoice.process = {
                error: response.data?.message || response.data || 'Email failed - check the recipient address(es) and try again'
              };
              invoice.deliveryStatus = 6; // EmailFailed
              invoice.invoiceState = 'email failed';
              invoice.invoiceColor = 'bg-red-600';
              return response;
            }
            invoice.process = {
              done: true
            };
            invoice.selected = false;
            // Optimistically update delivery state so UI reflects "emailing"
            // without requiring a page refresh
            invoice.deliveryStatus = 5; // Emailing
            invoice.deliveryFailureMessage = '';
            invoice.invoiceState = 'emailing';
            invoice.invoiceColor = 'bg-action-grey';
            return response;
          }).catch(err => {
            invoice.process = {
              error: err.data?.message || err.body?.message || 'Email failed'
            };
            invoice.deliveryStatus = 6; // EmailFailed
            invoice.invoiceState = 'email failed';
            invoice.invoiceColor = 'bg-red-600';
          });
        }
        return leanLawApi.updateInvoice({
          id: invoice.id,
          body: {
            invoiceState: option.id === 'approve' ? 'approved' : option.id
          }
        }).then(processed => {
          invoice.process = {
            done: true
          };
          invoice.selected = false;
          return processed;
        }).catch(err => {
          invoice.process = {
            error: err.body.message
          };
        });
      });
    });
    return process.then(() => true);
  }
  function pluralize(n, word) {
    if (n == 0) return `no ${word}s`;
    if (n == 1) return `one ${word}`;
    return `${n} ${word}s`;
  }
  function groupInvoices(invoices, trust) {
    // group invoices by same client/matter because we create one payment for each group
    return invoices.filter(i => i.state.balance && (!trust || i.trustBalance)).reduce((g, invoice) => {
      const billClient = invoice.client.billing?.billClient || !invoice.matter;
      const id = billClient ? invoice.client.id : invoice.matter.id;
      if (!g[id]) {
        g[id] = {
          id,
          invoices: [],
          trustBalance: invoice.trustBalance,
          billClient,
          client: invoice.client
        };
      }
      g[id].invoices.push(invoice);
      return g;
    }, {});
  }
  function processPayment(group, payment) {
    group.invoices.forEach(i => {
      i.process = {
        processing: true
      };
    });
    group.invoices.sort((a, b) => a.invoiceDate > b.invoiceDate ? 1 : -1);
    const reference = group.invoices.map(i => i.reference).join(',');
    payment.description = `Payment of ${group.invoices.length > 1 ? 'invoices' : 'invoice'} ${reference}`;
    payment.invoices = group.invoices.map(i => i.id);
    const request = {
      id: group.id,
      body: payment
    };
    const api = group.billClient ? leanLawApi.createClientPayment(request) : leanLawApi.createMatterPayment(request);
    return api.then(payment => {
      group.invoices.forEach(i => {
        i.process = {
          done: true
        };
      });
      return payment;
    }).catch(err => {
      const error = err.body ? err.body.message || err.body : err;
      group.invoices.forEach(i => {
        i.process = {
          error
        };
      });
    });
  }
  return {
    processApi,
    pluralize,
    processPayment,
    groupInvoices
  };
}]);